import { ExclamationCircleOutlined } from "@ant-design/icons";
import { App, Form } from "antd";

import { OpportunitySelect } from "../../components/selects/opportunity-select";
import { useMergeOpportunities } from "../../data/use-opportunities";
import { useOnChange } from "../../hooks/use-on-change";
import { Modal } from "components/modal";

export const MergeOpportunitiesModal = (props) => {
  const { close, isOpen } = props;

  const { modal } = App.useApp();

  const mergeOpportunities = useMergeOpportunities({
    onSuccess: close,
  });

  const [form] = Form.useForm();

  useOnChange(
    isOpen,
    () => {
      if (!isOpen) {
        return;
      }

      form.setFieldsValue({
        childIds: [],
        parentId: null,
      });
    },
    [isOpen, form]
  );

  return (
    <Modal
      confirmLoading={mergeOpportunities.isLoading}
      okText="Merge"
      onCancel={close}
      onOk={form.submit}
      title="Merge Opportunities"
      open={isOpen}
    >
      <Form
        form={form}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 18 }}
        onFinish={(values) => {
          modal.confirm({
            title: "Are you sure you want to merge these opportunities?",
            icon: <ExclamationCircleOutlined />,
            content: "This cannot be undone!",
            okText: "Yes",
            okType: "danger",
            cancelText: "No",
            onOk: () => mergeOpportunities.mutate(values),
          });
        }}
      >
        <div style={{ marginBottom: "16px" }}>
          The secondary opportunity relationships will be reassigned to the
          primary opportunity. The secondary opportunities will then be
          archived.
        </div>
        <div style={{ marginBottom: "16px" }}>
          <strong>
            If you wish to retain any fields, please update them prior to
            merging.
          </strong>
        </div>
        <OpportunitySelect
          label="Primary"
          name="parentId"
          rules={[{ required: true }]}
        />
        <OpportunitySelect
          label="Secondary"
          mode="multiple"
          name="childIds"
          rules={[{ required: true }]}
        />
      </Form>
    </Modal>
  );
};
